import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { UnidadeConsumidora } from '../../types';
import UnidadeForm from './UnidadeForm';

interface UnidadeModalProps {
    isOpen: boolean;
    onClose: () => void;
    unidade?: UnidadeConsumidora | null;
    initialNegotiation?: { id: number, cliente_nome: string };
    /** Valores iniciais ao criar uma nova UC (ex: clonar dados de outra UC no aditivo contratual) */
    prefill?: Partial<UnidadeConsumidora> | null;
    onSave: () => void;
}

const UnidadeModal: React.FC<UnidadeModalProps> = ({ isOpen, onClose, unidade, initialNegotiation, prefill, onSave }) => {
    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in">
            <div className="bg-white dark:bg-slate-900 rounded-2xl w-full max-w-lg md:max-w-[75%] shadow-2xl overflow-hidden transform scale-100 transition-all max-h-[90vh] flex flex-col border border-transparent dark:border-slate-800">
                {/* Header */}
                <div className="px-6 py-4 border-b border-primary/20 dark:border-slate-800 flex justify-between items-center bg-primary flex-shrink-0">
                    <h3 className="font-poppins font-bold text-white text-lg">
                        {unidade ? 'Editar Unidade Consumidora' : 'Nova Unidade Consumidora'}
                    </h3>
                    <button
                        type="button"
                        onClick={onClose}
                        className="p-2 hover:bg-white/10 rounded-full transition-colors text-white/80 hover:text-white"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="overflow-y-auto custom-scrollbar flex-1">
                    <UnidadeForm
                        isOpen={isOpen}
                        onClose={onClose}
                        unidade={unidade}
                        initialNegotiation={initialNegotiation}
                        prefill={prefill}
                        onSave={onSave}
                    />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default UnidadeModal;
